import calendarComponentComponent from './calendarComponent.component';

let calendarComponentModule = angular.module('vacations-absences.calendarComponent', [])

.component('calendarComponent', calendarComponentComponent)

.name;

export default calendarComponentModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarComponent/calendarComponent.js